import { effect, Injectable, signal, WritableSignal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

import { LocalTaxonomy, Taxonomy } from '../pages/taxonomy-dashboard-v2/taxonomy.model';
import { EmptySelectionTaxonomy } from '../pages/taxonomy-dashboard-v2/taxonomy.constants';
import { TaxonomyApiService } from './api-services/taxonomy-api.service';

@Injectable({
  providedIn: 'root',
})
export class TaxonomyService {
  private updateTaxonomySource = new BehaviorSubject<void>(undefined);
  private _selectedTaxonomyItem = signal<LocalTaxonomy>({ ...EmptySelectionTaxonomy });
  private _editIndex: number = -1;
  updateTaxonomy$ = this.updateTaxonomySource.asObservable();

  // HANDLE ENTITY FORM ACTION FLAG
  entitityFormFlag:string = "";
  // ACTIVE SELECTED TAXONOMY DATA
  selectedTaxonomy:any ;
  // ACTIVE SELECTED ENTITIES
  selectedEnitity:any={LinkedEntities:[]} ;
  enitity:any ;

  // SIGNAL FOR TAXOCHECKFLAG
  taxoCheckFlag = signal<string>("default");

  updateTaxoCheckFlag(value: string) {
    this.taxoCheckFlag.set(value);
  }

  constructor(private router: Router, private taxonomyApiService: TaxonomyApiService) {
    effect(
      () => {
        const selected = this._selectedValue();
        if (selected) {
          this.navigateToTaxonomyPage(selected.taxonomy_id);
        }
      },
      { allowSignalWrites: true }
    );
  }

  // Method to trigger the update event
  triggerTaxonomyUpdate() {
    this.updateTaxonomySource.next(); // Notify subscribers
  }

  public get taxonomyItem(): WritableSignal<LocalTaxonomy> {
    return this._selectedTaxonomyItem;
  }

  setTaxonomyItem(data: LocalTaxonomy): void {
    this._selectedTaxonomyItem.set(data);
    this._editIndex = this._taxonomiesData().findIndex((obj) => obj.taxonomy_id == data.taxonomy_id);
  }

  public get taxonomyData(): WritableSignal<LocalTaxonomy[]> {
    return this._taxonomiesData;
  }

  setTaxonomyData(data: Taxonomy[]): void {
    const dataWIthIndex = data.map((item, index) => ({ id: index + 1, ...item }));
    this._taxonomiesData.set(dataWIthIndex);
  }

  saveTaxonomyData(data: LocalTaxonomy) {
    const newData = [...this._taxonomiesData(), data];
    this.setTaxonomyData(newData);
  }

  _list_of_taxonomies = signal<{ taxonomy_id: string; taxonomy_name: string }[]>([]);
  _taxonomiesData = signal<any[]>([]);

  getListOfTaxonomies(res: any) {
    this._taxonomiesData.set(res.data);

    this._list_of_taxonomies.set(
      res.data.map((item: any) => ({
        taxonomy_id: item.taxonomy_id,
        taxonomy_name: item.taxonomy_name
      }))
    );
  }

  getTaxonomiesData() {
    return this._taxonomiesData; // Expose the signal
  }

  setTaxonomiesData(res: any) {
    this._taxonomiesData.set(res.data);
  }

  private _selectedValue = signal<{ taxonomy_id: string; taxonomy_name: string } | null>(null);

  setSelectedValue(value: { taxonomy_id: string; taxonomy_name: string } | null) {
    this.selectedTaxonomy =  value||{}
    this._selectedValue.set(value);
  }

  getSelectedValue() {
    return this._selectedValue;
  }

  navigateToTaxonomyPage(id: string): void {
    console.log("FUNCTION CALLED");
    this.router.navigate(['/taxonomy-dashboard', id]);
  }

  loadTaxonomy() {
    this.taxonomyApiService.getTaxonomyV2({}).subscribe((res) => {
      this.getListOfTaxonomies(res);
      this.setTaxonomiesData(res);
    });
  }
}
